import type { PathologyAction, PathologyStage, PathologyTestStatus, WorklistStatusFilter } from './types';

export const formatPathologyDateTime = (value: string | null | undefined) => {
  if (!value) return '--';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '--';
  const parts = new Intl.DateTimeFormat('en-IN', {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true, timeZone: 'Asia/Kolkata',
  }).formatToParts(date);
  const get = (type: Intl.DateTimeFormatPartTypes) => parts.find((part) => part.type === type)?.value ?? '';
  return `${get('day')}-${get('month')}-${get('year')} ${get('hour')}:${get('minute')} ${get('dayPeriod').toUpperCase()}`;
};

export const todayInput = () => {
  const date = new Date();
  const offset = date.getTimezoneOffset();
  return new Date(date.getTime() - offset * 60_000).toISOString().slice(0, 10);
};

export const ageDisplay = (snapshot: { ageYears: number; ageMonths: number; ageDays: number }) =>
  `${snapshot.ageYears}Y ${snapshot.ageMonths}M ${snapshot.ageDays}D`;

export const testStatusLabels: Record<PathologyTestStatus, string> = {
  'bill-created': 'Only Bill Created',
  'sample-collected': 'Sample Collected',
  'lab-received': 'Lab Received',
  'report-generated': 'Report Generated',
  'report-delivered': 'Report Delivered',
};

export const pathologyStageConfig: Record<PathologyStage, { label: string; action: PathologyAction; actionLabel: string }> = {
  collection: { label: 'Collection', action: 'collect', actionLabel: 'Collect' },
  'lab-received': { label: 'Lab Received', action: 'lab-receive', actionLabel: 'Receive' },
  'report-generated': { label: 'Report Generated', action: 'generate-report', actionLabel: 'Generate' },
};

export const pathologyStages: PathologyStage[] = ['collection', 'lab-received', 'report-generated'];

export interface WorklistStatusOption {
  label: string;
  value: WorklistStatusFilter;
}

export const pathologyStageStatusOptions: Record<PathologyStage, WorklistStatusOption[]> = {
  collection: [
    { label: 'All', value: 'all' },
    { label: 'Collected', value: 'sample-collected' },
    { label: 'Not Collected', value: 'bill-created' },
  ],
  'lab-received': [
    { label: 'All', value: 'all' },
    { label: 'Received By Lab', value: 'lab-received' },
    { label: 'Not Receive By Lab', value: 'sample-collected' },
  ],
  'report-generated': [
    { label: 'All', value: 'all' },
    { label: 'Report Updated', value: 'report-generated' },
    { label: 'Report Not Update', value: 'lab-received' },
    { label: 'Report Delivered', value: 'report-delivered' },
  ],
};

export const readyReportStatusOptions: WorklistStatusOption[] = [
  { label: 'All', value: 'all' },
  { label: 'Report Delivered', value: 'report-delivered' },
  { label: 'Report Not Delivered', value: 'report-generated' },
];

export const departmentReportStatusOptions: WorklistStatusOption[] = [
  { label: 'All', value: 'all' },
  { label: 'Report Not Update', value: 'bill-created' },
  { label: 'Report Updated', value: 'report-generated' },
  { label: 'Report Delivered', value: 'report-delivered' },
];

export const defaultStatusForStage: Record<PathologyStage, WorklistStatusFilter> = {
  collection: 'bill-created',
  'lab-received': 'sample-collected',
  'report-generated': 'lab-received',
};
